import { render, staticRenderFns } from "./PlatformInfoTop.vue?vue&type=template&id=4de3c2fa&scoped=true"
import script from "./PlatformInfoTop.vue?vue&type=script&lang=js"
export * from "./PlatformInfoTop.vue?vue&type=script&lang=js"
import style0 from "./PlatformInfoTop.vue?vue&type=style&index=0&id=4de3c2fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de3c2fa",
  null
  
)

export default component.exports